import { ErrorHandler, Injectable, inject, isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';
import { MensagensErroFrontend } from '../constants/mensagens-erro-frontend';
import { AngularErrorCode } from '../enums/error.enum';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private readonly toastService = inject(ToastService);
  private readonly router = inject(Router);

  handleError(error: unknown): void {
    const mensagem =
      error instanceof Error
        ? error.message
        : String(error ?? 'Erro desconhecido');

    if (this.ehErroDeRotaNaoEncontrada(mensagem)) {
      this.router.navigate(['/not-found']);
      return;
    }

    if (isDevMode()) {
      console.error(error);
      return;
    }

    this.toastService.showErrorToast(
      'Erro',
      MensagensErroFrontend.ERRO_INESPERADO,
    );
  }

  private ehErroDeRotaNaoEncontrada(mensagem: string): boolean {
    return (
      mensagem.includes(AngularErrorCode.ROTA_NAO_ENCONTRADA) ||
      mensagem.toLowerCase().includes('cannot match any routes')
    );
  }
}
